import { render, staticRenderFns } from "./PurchasingInstructionReportChart.vue?vue&type=template&id=10d38213&"
import script from "./PurchasingInstructionReportChart.vue?vue&type=script&lang=js&"
export * from "./PurchasingInstructionReportChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports